module.exports = __webpack_public_path__ + "static/media/19CompraPaquetes-19.94bf0558.png";